
import { useEventListener, useMutationObserver } from '@vueuse/core'
import { scrollIntoView } from 'vessel/utils'

export default {
  name: 'VsMagellan',
  inheritAttrs: false,
  props: {
    scrollContainer: {
      type: String,
      default: null
    },
    scrollBehavior: {
      type: String,
      default: 'smooth'
    },
    offset: {
      type: [String, Number],
      default: 0
    },
    activeClass: {
      type: String,
      default: 'active'
    },
    highlightFirst: {
      type: Boolean,
      default: true
    },
    updateHash: {
      type: Boolean,
      default: true
    },
    link: {
      type: String,
      default: 'a[href^="#"]'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  methods: {
    highlightItem(item) {
      this.items.forEach(({ link }) => {
        link.classList.remove(this.activeClass)
      })

      item.link.classList.add(this.activeClass)
    },
    scrollToItem(item) {
      const parent = document.querySelector(this.scrollContainer)

      scrollIntoView(item.node, {
        container: parent,
        offset: this.offset,
        behavior: this.scrollBehavior
      })
    },
    onActivateItem(event) {
      event.preventDefault()

      const hash = event.target.getAttribute('href')
      const item = (this.items || []).find(ob => ob.hash == hash)

      if (item == null) {
        return false
      }

      if (this.updateHash) {
        item.node.style.scrollMargin   = `${this.offset}px`
        item.root.style.scrollBehavior = this.scrollBehavior

        this.$router.push({ hash: item.hash })
      } else {
        this.scrollToItem(item)
      }
    },
    onUpdateChildren() {
      this.items = []

      this.$el.querySelectorAll(this.link).forEach(link => {
        const hash = link.getAttribute('href')
        const item = { hash, link }

        Object.defineProperty(item, 'node', {
          get: () => document.querySelector(hash)
        })

        Object.defineProperty(item, 'root', {
          get: () => document.querySelector(this.scrollContainer || 'html')
        })

        link.removeEventListener('click', this.onActivateItem)
        link.addEventListener('click', this.onActivateItem)

        this.items.push(item)
      })

      if (this.highlightFirst && this.items.length && !this.firstHighlighted) {
        this.firstHighlighted = true
        this.highlightItem(this.items[0])
      }

      if (this.updateHash && this.$route.hash && this.items.length) {
        const item = this.items.find(
          ({ hash }) => hash == this.$route.hash
        )

        if (item && item.node && !this.hashScrolled) {
          this.hashScrolled = true
          this.scrollToItem(item)
        }
      }
    },
    onWindowScroll() {
      const targets = this.items.filter(item => {
        if (item.node) {
          const rect = item.node.getBoundingClientRect()
          item.ratio = rect.top

          return rect.top >= this.offset || rect.bottom > this.offset
        } else {
          return false
        }
      })

      const visible = targets.sort(
        (a, b) => a.ratio - b.ratio
      )

      if (visible.length) {
        const item = visible[0]
        this.highlightItem(item)

        this.$emit('changed', item.link)
      }
    }
  },
  beforeMount() {
    useMutationObserver(this.$el, this.onUpdateChildren, {
      childList: true,
      subtree: true
    })

    useEventListener(window, 'scroll', this.onWindowScroll, {
      capture: false,
      passive: true
    })
  },
  mounted() {
    this.onUpdateChildren()
  }
}
